export default "__VITE_ASSET__zNkT4ixL__"